




























import Vue from 'vue';
import {
  VegetarianDishList,
  ChivesList,
  CookMethodsList
} from '@/configs/what-will-i-eat';
import { randomNumber } from '@/core/utils';

export default Vue.extend({
  data() {
    return {
      VegetarianDishList,
      ChivesList,
      CookMethodsList,
      result: ''
    };
  },

  methods: {
    getResult() {
      const vegetarianDishIndex = randomNumber(
        0,
        this.VegetarianDishList.length - 1
      );
      const chivesIndex = randomNumber(0, this.ChivesList.length - 1);
      const cookMethodIndex = randomNumber(0, this.CookMethodsList.length - 1);
      this.result = `
        ${this.VegetarianDishList[vegetarianDishIndex]}
        ${this.CookMethodsList[cookMethodIndex]}
        ${this.ChivesList[chivesIndex]}
      `;
    }
  }
});
